<template>
  <m-withdraw-modal2 v-if="'2' === paramMapAll['USER_WITHDRAW_TEMPLATE']" ref="currentModal"></m-withdraw-modal2>
  <m-withdraw-modal1 v-else ref="currentModal"></m-withdraw-modal1>
</template>

<script>
import MWithdrawModal1 from "./WithdrawModal1.vue";
import MWithdrawModal2 from "./WithdrawModal2.vue";
export default {
  name: 'MWithdrawModal',
  components: {MWithdrawModal1, MWithdrawModal2},
  computed: {
    ...Vuex.mapGetters([
      "paramMapAll"
    ])
  },
  data() {
    return {}
  },
  created() {
  },
  methods: {
    show() {
      // 代理调用当前显示的子组件的 show 方法
      const modal = this.$refs.currentModal;
      if (modal && typeof modal.show === "function") {
        modal.show();
      } else {
        console.warn("当前模态框未准备好或未定义 show 方法");
      }
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
